import React from "react"

function NoDataFound(props) {
  const { colspan, text } = props

  return (
    <tr>
      <td colSpan={colspan ? colspan : 100} className="py-16 text-center">
        <div className="flex flex-col items-center justify-center">
            <p className="text-sm font-medium text-foreground">{text ? text : "No Data Found"}</p>
            <p className="mt-1 text-xs text-muted-foreground">No records match your search criteria</p>
        </div>
      </td>
    </tr>
  )
}

export default NoDataFound;